(() => {
  const root = window.Shopify?.routes?.root || "/";
  const drawer = document.querySelector("[data-cart-drawer]");
  const overlay = document.querySelector("[data-cart-overlay]");
  const content = document.querySelector("[data-cart-content]");
  const toast = document.querySelector("[data-toast]");

  const escapeHtml = (value = "") =>
    String(value).replace(/[&<>'"]/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "'": "&#039;",
      '"': "&quot;",
    })[char]);

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || "TRY";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "tr-TR", {
        style: "currency",
        currency,
        minimumFractionDigits: currency === "TRY" ? 0 : 2,
      }).format(cents / 100);
    } catch {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("show");
    window.setTimeout(() => toast.classList.remove("show"), 2600);
  };

  const openCart = () => {
    drawer?.classList.add("open");
    overlay?.classList.add("visible");
    drawer?.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  };

  const closeCart = () => {
    drawer?.classList.remove("open");
    overlay?.classList.remove("visible");
    drawer?.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  const updateCounts = (count) => {
    document.querySelectorAll("[data-cart-count]").forEach((node) => {
      node.textContent = count;
    });
  };

  const itemMarkup = (item, index) => `
    <div class="cart-product" data-line="${index + 1}">
      <div class="cart-thumb">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ""}</div>
      <div>
        <strong>${escapeHtml(item.product_title)}</strong>
        <span>${escapeHtml(item.variant_title || "")}</span>
        <div class="quantity-control">
          <button type="button" data-cart-minus aria-label="Adedi azalt">−</button>
          <span>${item.quantity}</span>
          <button type="button" data-cart-plus aria-label="Adedi artır">+</button>
        </div>
      </div>
      <strong>${formatMoney(item.final_line_price)}</strong>
    </div>`;

  const renderCart = (cart) => {
    updateCounts(cart.item_count);
    if (!content) return;
    if (!cart.item_count) {
      content.innerHTML = `<div class="empty-cart"><h3>Sepetin şu an boş.</h3><p>Günün her anında pürüzsüz saçlar için GoBrush Pro’yu keşfet.</p><button class="outline-button" type="button" data-cart-close>Ürünü İncele</button></div>`;
      return;
    }
    content.innerHTML = `${cart.items.map(itemMarkup).join("")}
      <div class="shipping-progress"><span>Ücretsiz kargo kazandın</span><div><i></i></div></div>
      <div class="cart-total"><span>Ara Toplam</span><strong>${formatMoney(cart.total_price)}</strong></div>
      <p class="cart-note">Kargo ücretsiz. Vergiler ödeme adımında hesaplanır.</p>
      <a class="gradient-button checkout-button" href="${root}checkout">Güvenli Ödemeye Geç</a>
      <p class="secure-note">🔒 Shopify korumalı güvenli ödeme</p>`;
  };

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Sepet yüklenemedi");
    return response.json();
  };

  const refreshCart = async () => {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  };

  const addToCart = async (button) => {
    const id = Number(button.dataset.variantId);
    if (!id) {
      showToast("Önce tema ayarından GoBrush Pro ürününü seçin.");
      return;
    }
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error("Ürün sepete eklenemedi");
      await refreshCart();
      openCart();
      showToast("GoBrush Pro sepetine eklendi.");
    } catch (error) {
      showToast(error.message || "Bir sorun oluştu.");
    } finally {
      button.disabled = false;
    }
  };

  const changeLine = async (line, quantity) => {
    const response = await fetch(`${root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    if (!response.ok) throw new Error("Sepet güncellenemedi");
    renderCart(await response.json());
  };

  document.addEventListener("click", async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const addButton = target.closest(".js-add-to-cart");
    if (addButton) {
      event.preventDefault();
      await addToCart(addButton);
      return;
    }
    if (target.closest("[data-cart-open]")) {
      event.preventDefault();
      try { await refreshCart(); } catch {}
      openCart();
      return;
    }
    if (target.closest("[data-cart-close]") || target.closest("[data-cart-overlay]")) {
      closeCart();
      return;
    }
    const quantityButton = target.closest("[data-cart-minus], [data-cart-plus]");
    if (quantityButton) {
      const row = quantityButton.closest("[data-line]");
      const line = Number(row?.dataset.line);
      const current = Number(row?.querySelector(".quantity-control span")?.textContent || 0);
      const next = quantityButton.hasAttribute("data-cart-plus") ? current + 1 : Math.max(0, current - 1);
      try { await changeLine(line, next); } catch (error) { showToast(error.message); }
      return;
    }
    const faqButton = target.closest(".faq-list button");
    if (faqButton) {
      const article = faqButton.closest("article");
      const wasOpen = article.classList.contains("open");
      document.querySelectorAll(".faq-list article").forEach((item) => {
        item.classList.remove("open");
        const button = item.querySelector("button");
        button?.setAttribute("aria-expanded", "false");
        const sign = button?.querySelector("span");
        if (sign) sign.textContent = "+";
      });
      if (!wasOpen) {
        article.classList.add("open");
        faqButton.setAttribute("aria-expanded", "true");
        const sign = faqButton.querySelector("span");
        if (sign) sign.textContent = "−";
      }
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeCart();
  });
})();
